export function helpButtonDirective() {
    return {
        restrict: 'E',
        template: `
            <md-button class="md-icon-button" ng-click="onClick()">
                <md-icon>help</md-icon>
                <md-tooltip>{{ hint }}</md-tooltip>
            </md-button>
        `,
        scope: {
            hint: '@hint',
            onClick: '&onClick',
        },
    };
}
